import { useQuery } from '@tanstack/react-query'
import { getUserReshapeSettings } from '../../../../apis/userDetailedSettings'
import { queryKeys } from '../../../../shared'

/**
 * Reshape設定 Query hook
 */
export const useReshapeSettingsQuery = () => {
  return useQuery({
    queryKey: queryKeys.ocrSettings.reshape(),
    queryFn: getUserReshapeSettings,
  })
}
